import type { SubGuideNodeType } from '@/nodes/types';
import type { GuideNodeId } from '@rock/types';
import { outgoingHandles } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import type { FC } from 'react';

const SubGuideNode: FC<NodeProps<SubGuideNodeType>> = ({ id, data }) => {
    const paths = outgoingHandles['sub-guide'](id as GuideNodeId, data);
    return (
        <div className="border-1 rounded-lg m-1 px-3 py-2 bg-teal-50 border-teal-300">
            <div className="flex flex-col items-center justify-center">
                <div className="text-sm font-bold text-teal-900">SUB-GUIDE</div>
                <div className="text-[6pt] text-teal-900">{data.equipmentTypeId}</div>
                <div className="text-[6pt] text-teal-700">{data.scopeKey}</div>
            </div>

            <Handle type="target" position={Position.Left} />
            <Handle type="source" id={paths.next} position={Position.Right} />
        </div>
    );
};

export default SubGuideNode;
